import { render } from "./LicensePageTabViewIntervals.vue?vue&type=template&id=fb5d4e5a&ts=true"
import script from "./LicensePageTabViewIntervals.vue?vue&type=script&lang=ts"
export * from "./LicensePageTabViewIntervals.vue?vue&type=script&lang=ts"

import "./LicensePageTabViewIntervals.vue?vue&type=style&index=0&id=fb5d4e5a&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__